import { IMAGE_BASE } from "../constants/stringConstants";

export const makeImageSrcByName = (name) => {
  return `${IMAGE_BASE}${name
    ?.replace("&", " ")
    .replace(/  +/g, " ")
    .replaceAll(" ", "-")}.jpg`;
};
